import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Нам шкода, що стаття не була корисною. Повідомте нам, що було не так?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Інформація, яку я шукаю, відсутня',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Є фактичні помилки',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Деякі питання залишаються незрозумілими',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Дайте нам трохи інформації, і ми покращимо цю статтю.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Надіслати'
    }
  }
};
